<template>
	<div class="exchange-box">
		<div class="carousel">
			<marquee class="container" behavior="" direction="">
				<div class="item" v-for="item in historyExchangeData.list">
					用户：*** {{ moment(item.CreatedAt).fromNow() }} 在
					<span class="red">{{ item.gameName }}</span>
					兑换了{{ item.amount }}
					{{ item.exchangeType === 0 ? "金元" : "银元" }}
				</div>
			</marquee>
		</div>

		<el-form label-width="90px" style="margin-top: 20px">
			<el-form-item label="金元" v-if="form.exchangeType == 0">
				{{ member.gamegold }}
			</el-form-item>
			<el-form-item label="银元" v-if="form.exchangeType == 1">
				{{ member.gamesilver }}
			</el-form-item>
			<el-form-item label="兑换方式">
				<el-radio-group v-model="form.exchangeType" v-if="!gameStore.exchangeGame.id">
					<el-radio :label="0"><img class="game-money-type" src="@/assets/images/gamegold.png" alt="">金元兑换
					</el-radio>
					<el-radio :label="1"><img class="game-money-type" src="@/assets/images/gamesilver.png" alt="">银元兑换
					</el-radio>
				</el-radio-group>
				<el-radio-group v-model="form.exchangeType" v-else>
					<template v-for="item in gameStore.exchangeGame.exchangeType">
						<el-radio :label="parseInt(item)">
							<template v-if="item==0">
								<img class="game-money-type" src="@/assets/images/gamegold.png" alt="">金元兑换
							</template>
							<template v-if="item==1">
								<img class="game-money-type" src="@/assets/images/gamesilver.png" alt="">银元兑换
							</template>
						</el-radio>
					</template>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="游戏类型" v-if="pagePosition!=='publicPage'">
				<el-radio-group v-model="form.gameType" @change="gameStore.exchangeGame={}">
					<el-radio :label="0">精品游戏
					</el-radio>
					<el-radio :label="1">百倍游戏
					</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="历史账号" v-show="historyExchangeData.account.length > 0">
				<el-radio-group v-model="form.account" size="medium">
					<el-radio border :label="item.account" v-for="item in historyExchangeData.account">
						{{ item.account }}
					</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="游戏账号">
				<el-input v-model="form.account" style="width: 240px" maxlength="10"></el-input>
				&emsp;输入对应的游戏账号注意不要有空格 账号长度4位到10位
			</el-form-item>
			<el-form-item label="选择游戏">
				<el-select v-model="gameStore.exchangeGame" value-key="id" filterable placeholder="请选择或搜索选择"
				           v-if="pagePosition!=='publicPage'">
					<template v-for="item in gameStore.gameList">
						<template v-if="form.gameType===0">
							<el-option
								v-if="item.exchangeRadio==1"
								:key="item.id"
								:label="item.name"
								:value="item">
							</el-option>
						</template>
						<template v-else>
							<el-option
								v-if="item.exchangeRadio!=1"
								:key="item.id"
								:label="item.name"
								:value="item">
							</el-option>
						</template>
					</template>
				</el-select>
				<el-input
					v-else
					v-model="gameStore.exchangeGame.name"
					style="width: 240px"
					readonly
					placeholder="Please input"
				/>
			</el-form-item>
			<el-form-item label="兑换充值">
				<el-input-number :min="form.exchangeType === 0?10:100"
				                 :max="form.exchangeType === 0?500:30000"
				                 v-model="form.amount" controls-position="right"></el-input-number>
				&emsp;
				<template v-if="gameStore.exchangeGame.id">
					<template v-if="form.exchangeType === 0 ">单次10到500之间(<span
						class="red">兑换比例 {{
							getRadio(form.exchangeType, gameStore.exchangeGame.exchangeRadio)
						}}</span>)
					</template>
					<template v-else>单次100到30000之间(<span
						class="red">兑换比例 {{
							getRadio(form.exchangeType, gameStore.exchangeGame.exchangeRadio)
						}}</span>)
					</template>
					<!-- 1倍版本，金元兑换时-->
					<template v-if="gameStore.exchangeGame.exchangeRadio == 1 && form.exchangeType==0">
						<span class="red">该游戏单笔兑换100金元及以上可获得双倍游戏充值</span>
					</template>
				</template>
			</el-form-item>
			<el-form-item>
				<el-button type="warning" :loading="globalStore.loading" @click="doExchange()">兑换</el-button>
				<el-button @click="initForm()">重置</el-button>
			</el-form-item>

		</el-form>
	</div>
</template>
<script setup>
import {ref, onMounted} from "vue"
import {useGlobalStore, useMemberStore, useGameStore} from '@/pinia'
import {storeToRefs} from "pinia";
import {getGame} from "@/api/game";
import {getMemberExchangeHistory, exchange} from "@/api/member"
import moment from "moment"
import {Message} from "element-ui";
import bus from "@/plugins/bus";

const memberStore = useMemberStore()
const globalStore = useGlobalStore()
const gameStore = useGameStore()
const {member} = storeToRefs(memberStore)


defineProps({
	pagePosition: String
})

const getRadio = (type, radio) => {
	if (type == 0) {
		return "1金元:" + radio + "充值"
	} else {
		return 100 / radio + "银元:" + "1充值"
	}
}

const historyExchangeData = ref({
	"account": [],
	"list": []
})


const doGetMemberExchangeHistory = async () => {
	let res = await getMemberExchangeHistory()
	if (res.code === 0) {
		historyExchangeData.value = res.data
	}
}


const form = ref({
	exchangeType: 0,
	gameType: 0,
	account: undefined,
	amount: undefined,
})


const doExchange = async () => {
	if (!form.value.account || !form.value.amount) {
		Message.error("字段请填写完整！")
		return
	}
	if ((form.value.exchangeType === 0 && form.value.amount > member.value.gamegold) || (form.value.exchangeType === 1 && form.value.amount > member.value.gamesilver)) {
		Message.error("您的可用额度不足！")
		return
	}

	form.value.gameId = gameStore.exchangeGame.id
	let res = await exchange(form.value)
	if (res.code === 0) {
		bus.emit('closeExchange')
		Message.success("兑换成功")
		bus.emit('memberInfo')
		form.value.account = undefined
		form.value.amount = undefined
	}
}

const initForm = () => {
	form.value = {
		exchangeType: 0,
		gameType: 0,
		account: undefined,
		amount: undefined,
	}
}


onMounted(() => {
	bus.emit('getGameList')
	doGetMemberExchangeHistory()
})

</script>

<style lang="scss" scoped>
.exchange-box {
	.red {
		color: red;
	}

	:deep(input[aria-hidden="true"]) {
		display: none !important;
	}

	:deep(.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner) {
		box-shadow: none !important;
	}

	.carousel {
		width: 100%;
		padding: 0 10px;
		font-size: 0;
		box-sizing: border-box;
		overflow: hidden;
		border: 1px solid rgba(204, 204, 204, 0.65);
		border-left-width: 4px;

		.container {
			user-select: none;
			line-height: 40px;

			.item {
				display: inline-block;
				margin-right: 20px;
				font-size: 14px;
			}
		}
	}

	.game-money-type {
		width: 25px;
		vertical-align: middle;
		margin: 0 10px;
	}

}
</style>